import React from "react";
import { motion } from "framer-motion";
import TodoTaskManagement from "./components/TodoTaskManagement";

const TodoTaskMain = () => {
  return (
    <motion.div
      className="mainPageRenderingContainer"
      style={{ padding: 0, background: "#F8FAFC", minHeight: "100vh" }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
    >
      <TodoTaskManagement />
    </motion.div>
  );
};

export default TodoTaskMain;
